import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(source, true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(source)).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _ from 'lodash';
import { styled, StyleSheet } from '@rexlabs/styling';
import React, { Component } from 'react';
import { autobind } from 'core-decorators';
import Types from 'prop-types';
import mixins from '../utils/style-mixins';
import { OptionPropType } from '../utils/custom-prop-types';
var SelectOption = (_dec = styled(StyleSheet({
  container: _objectSpread({}, mixins.clickStyles, {
    width: '100%',
    padding: '0.25em'
  }),
  isActive: {
    background: 'black',
    color: 'white'
  },
  isPassive: _objectSpread({}, mixins.disabledClickStyles, {
    color: 'grey'
  }),
  isSelected: {
    background: 'grey',
    color: 'white'
  }
})), _dec(_class = autobind(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(SelectOption, _Component);

  function SelectOption() {
    _classCallCheck(this, SelectOption);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelectOption).apply(this, arguments));
  }

  _createClass(SelectOption, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevIsActive = _ref.isActive;
      var _this$props = this.props,
          isActive = _this$props.isActive,
          scrollIntoView = _this$props.scrollIntoView; // When the option becomes active, we should scroll to it's position.

      if (isActive && !(prevIsActive === isActive)) {
        scrollIntoView(this.el);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          styles = _this$props2.styles,
          option = _this$props2.option,
          pluckLabel = _this$props2.pluckLabel,
          isActive = _this$props2.isActive,
          isPassive = _this$props2.isPassive,
          isSelected = _this$props2.isSelected;
      return React.createElement("div", _extends({}, styles('container', {
        isActive: isActive && !isPassive,
        isSelected: isSelected && !isPassive,
        isPassive: isPassive
      }), {
        ref: this.setRef,
        onMouseEnter: isPassive ? this.nullEvent : this.handleMouseEnter,
        onMouseMove: isPassive ? undefined : this.handleMouseMove,
        onMouseDown: isPassive ? this.nullEvent : this.handleMouseDown,
        onTouchStart: isPassive ? undefined : this.handleTouchStart,
        onTouchMove: isPassive ? undefined : this.handleTouchMove,
        onTouchEnd: isPassive ? this.nullEvent : this.handleTouchEnd
      }), pluckLabel(option));
    }
  }, {
    key: "setRef",
    value: function setRef(ref) {
      this.el = ref;
    }
  }, {
    key: "handleMouseHover",
    value: function handleMouseHover(event) {
      var _this$props3 = this.props,
          index = _this$props3.index,
          option = _this$props3.option,
          onHover = _this$props3.onHover;
      onHover(index, option, event);
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter(event) {
      this.handleMouseHover(event);
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      this.handleMouseHover(event);
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      var _this$props4 = this.props,
          option = _this$props4.option,
          onSelect = _this$props4.onSelect;
      onSelect(option, event);
    }
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart(event) {
      // When a touch starts from inside an Option, we know the screen *is not*
      // being dragged; we should hand it's end event with an `onSelect`.
      this.isBeingDragged = false;
    }
  }, {
    key: "handleTouchMove",
    value: function handleTouchMove(event) {
      // As soon as the user starts dragging there finger on an Option, we no
      // longer want to action it's end with an `onSelect`.
      this.isBeingDragged = true;
    }
  }, {
    key: "handleTouchEnd",
    value: function handleTouchEnd(event) {
      if (this.isBeingDragged) return;
      this.handleMouseDown(event);
    }
  }, {
    key: "nullEvent",
    value: function nullEvent(event) {
      event.stopPropagation();
      event.preventDefault();
    }
  }]);

  return SelectOption;
}(Component), _defineProperty(_class2, "propTypes", {
  styles: Types.func,

  /** The active index of the Option */
  index: Types.any,

  /** The data to display. */
  option: OptionPropType.isRequired,

  /** The helper for getting the 'label prop' from option. */
  pluckLabel: Types.func.isRequired,

  /** The helper for getting the 'value prop' from option. */
  pluckValue: Types.func,

  /** Whether this Option is actively hovered or reached by up/down. */
  isActive: Types.bool,

  /** Whether this Option is actively hovered or reached by up/down. */
  isPassive: Types.bool,

  /** Whether this Option is actively hovered or reached by up/down. */
  isSelected: Types.bool,

  /** Fires when the mouse/touch hovers over the Option: function (event) */
  onHover: Types.func,

  /** Fires when the Option is clicked or touched: function (event) */
  onSelect: Types.func,

  /** Helper util to call when this Option becomes active: function (element) */
  scrollIntoView: Types.func
}), _defineProperty(_class2, "defaultProps", {
  isPassive: false,
  onHover: _.noop,
  onSelect: _.noop
}), _temp)) || _class) || _class);
export default SelectOption;